<template>
  <a-card :bordered="false">
    <!-- 报表类型和日期范围选择 -->
    <div class="report-type-wrapper" style="margin-bottom: 16px">
      <div class="report-type-selector">
        <!-- 报表类型选择 -->
        <div class="report-type-tabs">
          <span
            :class="['report-type-tab', { active: reportType === 'daily' }]"
            @click="handleReportTypeChange('daily')"
          >
            日报
          </span>
          <span
            :class="['report-type-tab', { active: reportType === 'weekly' }]"
            @click="handleReportTypeChange('weekly')"
          >
            周报
          </span>
          <span
            :class="['report-type-tab', { active: reportType === 'monthly' }]"
            @click="handleReportTypeChange('monthly')"
          >
            月报
          </span>
        </div>
        <!-- 日期范围选择器 -->
        <div class="report-date-range">
          <!-- 日报：日期范围选择器 -->
          <a-range-picker
            v-if="reportType === 'daily'"
            v-model:value="dateRange"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            :placeholder="['年/月/日', '年/月/日']"
            style="width: 100%"
            class="no-border-radius-picker"
            @change="handleDateRangeChange"
          />
          <!-- 周报：周范围选择器（自定义显示格式：YYYY-MM 第几周） -->
          <a-range-picker
            v-if="reportType === 'weekly'"
            v-model:value="weekRange"
            mode="week"
            :format="formatWeekOfMonth"
            valueFormat="YYYY-MM-DD"
            :placeholder="['年月 第几周', '年月 第几周']"
            style="width: 100%"
            class="no-border-radius-picker"
            @change="handleWeekRangeChange"
          />
          <!-- 月报：月份范围选择器 -->
          <a-range-picker
            v-if="reportType === 'monthly'"
            v-model:value="monthRange"
            mode="month"
            format="YYYY-MM"
            valueFormat="YYYY-MM"
            :placeholder="['年月', '年月']"
            style="width: 100%"
            class="no-border-radius-picker"
            @change="handleMonthRangeChange"
          />
        </div>
      </div>
    </div>
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 默认显示的4个筛选项（按表格列顺序） -->
          <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
            <a-form-item label="员工ID" prop="employeeId">
              <a-input
                v-model:value="queryParam.employeeId"
                placeholder="请输入员工ID"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
            <a-form-item label="员工姓名" prop="employeeName">
              <a-input
                v-model:value="queryParam.employeeName"
                placeholder="请输入员工姓名"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
            <a-form-item label="手环ID" prop="wristbandId">
              <a-input
                v-model:value="queryParam.wristbandId"
                placeholder="请输入手环ID"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>

          <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
          <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
            <a-form-item>
              <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                  {{ advanced ? '收起' : '展开' }}
                  <UpOutlined v-if="advanced" />
                  <DownOutlined v-else />
                </a-button>
              </span>
            </a-form-item>
          </a-col>

          <!-- 高级搜索（按表格列顺序排列） -->
          <template v-if="advanced">
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="手环名称" prop="wristbandName">
                <a-input
                  v-model:value="queryParam.wristbandName"
                  placeholder="请输入手环名称"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 统计开始时间 -->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="统计开始时间" prop="startTime">-->
            <!--                  <a-date-picker style="width: 100%" v-model="queryParam.startTime" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!-- 统计结束时间 -->
            <!--              <a-col :md="8" :sm="24">-->
            <!--                <a-form-item label="统计结束时间" prop="endTime">-->
            <!--                  <a-date-picker style="width: 100%" v-model="queryParam.endTime" valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
            <!--                </a-form-item>-->
            <!--              </a-col>-->
            <!-- 步数 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="步数" prop="stepCount">
                <a-input-number
                  v-model:value="queryParam.stepCount"
                  placeholder="请输入步数"
                  :min="0"
                  :step="1"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 工作时长(分钟) -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="工作时长：" prop="totalDuration">
                <a-input-number
                  v-model:value="queryParam.totalDuration"
                  placeholder="请输入工作时长(分钟)"
                  :min="0"
                  :step="1"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 任务数 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="任务数" prop="taskNumber">
                <a-input-number
                  v-model:value="queryParam.taskNumber"
                  placeholder="请输入任务数"
                  :min="0"
                  :step="1"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 投诉工单数 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="投诉工单数" prop="complaintNumber">
                <a-input-number
                  v-model:value="queryParam.complaintNumber"
                  placeholder="请输入投诉工单数"
                  :min="0"
                  :step="1"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 健康预警次数 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item label="健康预警次数" prop="warningsNumber" :label-colon="false">
                <a-input-number
                  v-model:value="queryParam.warningsNumber"
                  placeholder="请输入健康预警次数"
                  :min="0"
                  :step="1"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>

            <!-- 展开后，按钮在最后一行 -->
            <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
              <a-form-item>
                <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                  <a-button type="primary" @click="handleQuery" class="search-button">查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button">重置</a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    {{ advanced ? '收起' : '展开' }}
                    <UpOutlined v-if="advanced" />
                    <DownOutlined v-else />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作 -->
    <div class="table-operations">
      <a-button
        type="text"
        shape="circle"
        @click="getList"
        v-hasPermi="['system:userOperations:refresh']"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <!-- <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['system:userOperations:add']"
          class="add-button"
        >
          <PlusOutlined />新增
        </a-button> -->
      <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['system:userOperations:edit']">-->
      <!--          <a-icon type="edit" />修改-->
      <!--        </a-button>-->
      <a-button
        :disabled="multiple"
        @click="handleDelete"
        v-hasPermi="['system:userOperations:remove']"
        class="no-border-button delete-button"
      >
        <DeleteOutlined />删除
      </a-button>
      <a-button
        type="primary"
        class="no-border-button delete-button"
        @click="handleExport"
        v-hasPermi="['system:userOperations:export']"
      >
        <a-icon type="download" />导出
      </a-button>
      <!-- <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
    </div>
    <!-- 增加修改 -->
    <create-form ref="createForm" @ok="getList" @close="getList" />
    <!-- 数据展示 -->
    <div style="margin-top: 20px">
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="tableColumns"
        :data-source="list"
        :row-selection="rowSelection"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2000 }"
        class="optimized-table"
      >
        <template #bodyCell="{ column, text, record, index }">
          <!-- 序号列 -->
          <template v-if="column.dataIndex === 'index'">
            <span>{{ (queryParam.pageNum - 1) * queryParam.pageSize + index + 1 }}</span>
          </template>
          <!-- 统计开始时间 -->
          <template v-else-if="column.dataIndex === 'startTime'">
            <span>{{ record.startTime ? parseTime(record.startTime) : '-' }}</span>
          </template>
          <!-- 统计结束时间 -->
          <template v-else-if="column.dataIndex === 'endTime'">
            <span>{{ record.endTime ? parseTime(record.endTime) : '-' }}</span>
          </template>
          <!-- 完成达标率：显示百分比 -->
          <template v-else-if="column.dataIndex === 'percentage'">
            <span>{{ record.percentage != null && record.percentage !== '' ? record.percentage + '%' : '-' }}</span>
          </template>
          <!-- 创建时间 -->
          <template v-else-if="column.dataIndex === 'createTime'">
            <span>{{ record.createTime ? parseTime(record.createTime) : '-' }}</span>
          </template>
          <!-- 操作列 -->
          <template v-else-if="column.dataIndex === 'operation'">
            <div v-if="record.id !== 1" class="table-action-buttons">
              <a @click="handleDelete(record)" v-hasPermi="['system:userOperations:remove']" class="delete-link">
                删除
              </a>
            </div>
          </template>
          <!-- 员工ID和手环ID：完整显示，不显示省略号 -->
          <template v-else-if="column.dataIndex === 'employeeId' || column.dataIndex === 'wristbandId'">
            <span class="full-text-cell">{{ text }}</span>
          </template>
          <!-- 其他字段：默认显示 text 值 -->
          <template v-else>
            <span>{{ text }}</span>
          </template>
        </template>
      </a-table>
    </div>
    <!-- 分页 -->
    <div class="pagination-wrapper">
      <div class="pagination-left">
        <span class="pagination-info">
          显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
          {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
        </span>
        <a-select
          v-model:value="queryParam.pageSize"
          style="width: 100px; margin-left: 8px"
          @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
          class="no-border-radius-select"
        >
          <a-select-option :value="10">10条/页</a-select-option>
          <a-select-option :value="20">20条/页</a-select-option>
          <a-select-option :value="50">50条/页</a-select-option>
          <a-select-option :value="100">100条/页</a-select-option>
        </a-select>
      </div>
      <div class="pagination-right">
        <a-pagination
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :show-total="false"
          @change="changeSize"
        />
        <span class="pagination-jump">
          到第
          <a-input-number
            v-model:value="jumpPage"
            :min="1"
            :max="Math.ceil(total / queryParam.pageSize)"
            style="width: 60px; margin: 0 4px"
            @pressEnter="handleJumpPage"
            class="no-border-radius-input-number"
          />
          页
        </span>
      </div>
    </div>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import { UpOutlined, DownOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { pageUserOperations, listUserOperations, delUserOperations } from '@/api/system/userOperations'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'UserOperations',
  components: {
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    DeleteOutlined,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 报表类型：daily-日报, weekly-周报, monthly-月报
      reportType: 'daily',
      // 日报：日期范围
      dateRange: [],
      // 周报：周范围
      weekRange: [],
      // 月报：月份范围
      monthRange: [],
      // 查询参数
      queryParam: {
        companyId: null,
        projectId: null,
        employeeId: null,
        employeeName: null,
        wristbandId: null,
        wristbandName: null,
        startTime: null,
        endTime: null,
        statStartTime: null, // 统计开始时间范围-开始（用于报表查询）
        statEndTime: null, // 统计开始时间范围-结束（用于报表查询）
        stepCount: null,
        totalDuration: null,
        taskNumber: null,
        completedNumber: null,
        complaintNumber: null,
        warningsNumber: null,
        status: null,
        sort: null,
        pageNum: 1,
        pageSize: 10,
      },
      // 跳转页码
      jumpPage: 1,
      columns: [
        // {
        //   title: '公司ID,关联{sys_dept.id}',
        //   dataIndex: 'companyId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '项目ID,关联{zb_project_info.id}',
        //   dataIndex: 'projectId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '员工ID',
          dataIndex: 'employeeId',
          align: 'center',
          ellipsis: false,
          customCell: () => {
            return {
              class: 'employee-id-cell',
            }
          },
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          align: 'center',
          width: 120,
          ellipsis: true,
        },
        {
          title: '手环ID',
          dataIndex: 'wristbandId',
          align: 'center',
          ellipsis: false,
          customCell: () => {
            return {
              class: 'wristband-id-cell',
            }
          },
        },
        {
          title: '手环名称',
          dataIndex: 'wristbandName',
          align: 'center',
          width: 120,
          ellipsis: true,
        },
        {
          title: '统计开始时间',
          dataIndex: 'startTime',
          align: 'center',
          width: 180,
        },
        {
          title: '统计结束时间',
          dataIndex: 'endTime',
          align: 'center',
          width: 180,
        },
        {
          title: '步数',
          dataIndex: 'stepCount',
          align: 'center',
          width: 100,
        },
        {
          title: '工作时长(分钟)',
          dataIndex: 'totalDuration',
          width: 150,
          align: 'center',
        },
        {
          title: '任务数',
          dataIndex: 'taskNumber',
          align: 'center',
          width: 100,
        },
        {
          title: '完成达标率',
          dataIndex: 'percentage',
          align: 'center',
          width: 120,
        },
        {
          title: '投诉工单数',
          dataIndex: 'complaintNumber',
          align: 'center',
          width: 120,
        },
        {
          title: '健康预警次数',
          dataIndex: 'warningsNumber',
          align: 'center',
          width: 130,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
        },
      ],
    }
  },
  created() {
    // 初始化时从 Vuex 获取项目ID
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    // 页面创建时加载数据列表
    this.getList()
    // 监听项目变化事件（使用 $root 事件总线）
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  computed: {
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
        },
        ...this.columns,
      ]
    },
    // 按钮样式
    submitButtonStyle() {
      return {}
    },
    // 行选择配置
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        fixed: true,
      }
    },
  },
  watch: {},
  methods: {
    /**
     * 格式化周显示：YYYY-MM 第几周（月份的第几周）
     * @param {moment} date - moment日期对象
     * @returns {String} 格式化后的字符串，如：2024-01 第1周
     */
    formatWeekOfMonth(date) {
      if (!date) return ''
      const m = moment(date)
      const year = m.year()
      const month = m.month() + 1

      // 计算该日期是月份的第几周
      // 获取该月份的第一天
      const firstDayOfMonth = moment(m).startOf('month')
      // 获取该日期所在周的第一天（周一）
      const firstDayOfWeek = moment(m).startOf('week')
      // 如果周的第一天在月份之前，则从月份第一天开始计算
      const startDate = firstDayOfWeek.isBefore(firstDayOfMonth) ? firstDayOfMonth : firstDayOfWeek
      // 计算从月份第一天到该周第一天的天数差
      const daysDiff = startDate.diff(firstDayOfMonth, 'days')
      // 计算是第几周：天数差除以7，向上取整，加1（因为第一周从0开始）
      const weekOfMonth = Math.floor(daysDiff / 7) + 1

      return `${year}-${String(month).padStart(2, '0')} 第${weekOfMonth}周`
    },
    /** 查询员工作业(每日)统计列表 */
    getList() {
      // 每次查询前同步 Vuex 中的当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageUserOperations(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.jumpPage = this.queryParam.pageNum
        this.loading = false
      })
    },
    /**
     * 处理项目变化事件
     * 当右侧项目选择发生变化时，更新查询参数并刷新列表
     * @param {Number} projectId - 新选中的项目ID（可能为 undefined，表示清空选择）
     */
    handleProjectChanged(projectId) {
      // 更新查询参数中的项目ID
      this.queryParam.projectId = projectId || undefined
      // 重置到第一页并刷新列表
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      // 从 Vuex 获取当前项目ID作为默认值
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        companyId: undefined,
        projectId: currentProjectId || undefined,
        employeeId: undefined,
        employeeName: undefined,
        wristbandId: undefined,
        wristbandName: undefined,
        startTime: undefined,
        endTime: undefined,
        statStartTime: undefined,
        statEndTime: undefined,
        stepCount: undefined,
        totalDuration: undefined,
        taskNumber: undefined,
        completedNumber: undefined,
        complaintNumber: undefined,
        warningsNumber: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      // 重置报表类型和日期范围
      this.reportType = 'daily'
      this.dateRange = []
      this.weekRange = []
      this.monthRange = []
      this.handleQuery()
    },
    /**
     * 处理报表类型变化
     * @param {String} type - 报表类型：daily/weekly/monthly
     */
    handleReportTypeChange(type) {
      this.reportType = type
      // 切换类型时清空日期范围
      this.dateRange = []
      this.weekRange = []
      this.monthRange = []
      // 清空查询参数中的时间
      this.queryParam.statStartTime = undefined
      this.queryParam.statEndTime = undefined
    },
    /**
     * 处理日报日期范围变化
     * @param {Array} dates - 日期范围数组 [startDate, endDate]
     */
    handleDateRangeChange(dates) {
      this.dateRange = dates || []
      if (dates && dates.length === 2) {
        // 日报：查询统计开始时间在指定日期范围内的数据
        // 开始时间为当天的 00:00:00，结束时间为当天的 23:59:59
        this.queryParam.statStartTime = dates[0] + ' 00:00:00'
        this.queryParam.statEndTime = dates[1] + ' 23:59:59'
      } else {
        this.queryParam.statStartTime = undefined
        this.queryParam.statEndTime = undefined
      }
    },
    /**
     * 处理周报周范围变化
     * @param {Array} dates - 周范围数组 [startDate, endDate] (格式：YYYY-MM-DD)
     */
    handleWeekRangeChange(dates) {
      this.weekRange = dates || []
      if (dates && dates.length === 2) {
        // 周报：查询统计开始时间在指定周范围内的数据
        // 开始时间为第一天的 00:00:00，结束时间为最后一天的 23:59:59
        this.queryParam.statStartTime = dates[0] + ' 00:00:00'
        this.queryParam.statEndTime = dates[1] + ' 23:59:59'
      } else {
        this.queryParam.statStartTime = undefined
        this.queryParam.statEndTime = undefined
      }
    },
    /**
     * 处理月报月份范围变化
     * @param {Array} months - 月份范围数组 [startMonth, endMonth] (格式：YYYY-MM)
     */
    handleMonthRangeChange(months) {
      this.monthRange = months || []
      if (months && months.length === 2) {
        // 月报：查询统计开始时间在指定月份范围内的数据
        // 开始时间为第一个月的第一天 00:00:00，结束时间为最后一个月最后一天 23:59:59
        const startDate = months[0] + '-01'
        // 计算最后一天
        const endMonth = months[1]
        const endDate = this.getMonthLastDay(endMonth)
        this.queryParam.statStartTime = startDate + ' 00:00:00'
        this.queryParam.statEndTime = endDate + ' 23:59:59'
      } else {
        this.queryParam.statStartTime = undefined
        this.queryParam.statEndTime = undefined
      }
    },
    /**
     * 获取指定月份的最后一天
     * @param {String} month - 月份字符串，格式：YYYY-MM
     * @returns {String} 最后一天，格式：YYYY-MM-DD
     */
    getMonthLastDay(month) {
      const [year, monthNum] = month.split('-').map(Number)
      // 下个月的第一天减去1天，就是本月的最后一天
      const lastDay = new Date(year, monthNum, 0).getDate()
      return `${year}-${String(monthNum).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    /**
     * 跳转页码
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      // 计算序号
      let serialNumbers = []
      if (row && row.id) {
        // 单条删除：在list中找到该记录的索引
        const index = that.list.findIndex((item) => item.id === row.id)
        if (index !== -1) {
          const serialNumber = (that.queryParam.pageNum - 1) * that.queryParam.pageSize + index + 1
          serialNumbers = [serialNumber]
        }
      } else {
        // 批量删除：遍历selectedRows，在list中找到每条记录的索引
        that.selectedRows.forEach((selectedRow) => {
          const index = that.list.findIndex((item) => item.id === selectedRow.id)
          if (index !== -1) {
            const serialNumber = (that.queryParam.pageNum - 1) * that.queryParam.pageSize + index + 1
            serialNumbers.push(serialNumber)
          }
        })
      }
      const serialNumbersText = serialNumbers.length > 0 ? serialNumbers.join('、') : '未知'
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为：' + serialNumbersText + ' 的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delUserOperations(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/user-operations/export',
            {
              ...that.queryParam,
            },
            `员工作业(每日)统计_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 搜索栏 FormItem 布局：左侧文字固定 80px，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker-input) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker-input > input) {
  border-radius: 0 !important;
}

/* 确保日期选择器所有相关元素都没有圆角 */
.report-date-range :deep(.ant-picker),
.report-date-range :deep(.ant-picker-input),
.report-date-range :deep(.ant-picker-input > input) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  background: #ffffff !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 报表日期范围选择器样式 */
.report-date-range :deep(.ant-picker) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 删除按钮颜色 - 红色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 删除按钮样式 - 参照 projectUser 页面的修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
  color: #000000 !important;
}

.pagination-wrapper :deep(.ant-input-number-input input) {
  color: #000000 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 员工ID和手环ID字段完整显示，不显示省略号，不换行，宽度自适应 */
.optimized-table :deep(.ant-table-tbody > tr > td.employee-id-cell),
.optimized-table :deep(.ant-table-tbody > tr > td.wristband-id-cell) {
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

.optimized-table :deep(.ant-table-tbody > tr > td .full-text-cell) {
  display: inline-block;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 全选按钮indeterminate状态：改为蓝色 */
.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate .ant-checkbox-inner::after) {
  background-color: #ffffff !important;
  border-top-color: #ffffff !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  border-left-color: transparent !important;
}

.optimized-table :deep(.ant-checkbox-indeterminate:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 报表类型选择器样式 */
.report-type-wrapper {
  background: #fff;
  border-radius: 8px;
}
.report-type-selector {
  display: flex;
  align-items: center;
  gap: 16px;
}
.report-type-tabs {
  display: flex;
  gap: 8px;
}
.report-type-tab {
  height: 32px;
  padding: 0 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  line-height: 1;
}
.report-type-tab:hover {
  border-color: #165dff;
  color: #165dff;
}
.report-type-tab.active {
  background: #165dff;
  border-color: #165dff;
  color: #fff;
}
.report-date-range {
  flex: 1;
  max-width: 400px;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>
